import axios from "axios";
import {
  signInRequested,
  signInRequestSucceeded,
  signInRequestFailed,
  signOut,
} from "../slices/signinSlice";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/User/LoadEmployeeData`;
const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const saveDatainLocalStorage = (datosDeSesion) => {
  localStorage.setItem("sesion", JSON.stringify(datosDeSesion));
};

const eliminarDatosDeSesionEnStorage = () => {
  localStorage.removeItem("sesion");
};

export const postApiData = (loginUser, token) => async (dispatch) => {
  try {
    dispatch(signInRequested());

    const postData = {
      UserName: loginUser,
      Token: token,
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data != "Invalid credentials!!") {
      const modifiedData = {
        userName: response.data.userName,
        email: response.data.email,
        employeeName: response.data.employeeName,
        employeeId: response.data.employeeId,
        position: response.data.position,
        rols: response.data.rols,
      };

      saveDatainLocalStorage(modifiedData);

      dispatch(signInRequestSucceeded(modifiedData));
    } else {
      dispatch(signInRequestFailed("Invalid credentials!!"));
    }
  } catch (error) {
    dispatch(signInRequestFailed(error.message));
  }
};

export const signOutUser = () => (dispatch) => {
  eliminarDatosDeSesionEnStorage();

  dispatch(signOut());
};
